import type * as React from 'react';

import { cn } from '../../styles/lib/utils';

type SkeletonLoaderProps = React.HTMLAttributes<HTMLDivElement> & {
  width?: number;
  height?: number;
  className?: string;
};

const SKELETON_ROW_HEIGHT = 16;

function SkeletonLoader({ width = 160, height = SKELETON_ROW_HEIGHT, className, ...props }: SkeletonLoaderProps) {
  return (
    <div
      data-slot="skeleton-loader"
      className={cn('bg-grey-30 rounded-[8px] animate-pulse', className)}
      style={{
        width: `${width}px`,
        height: `${height}px`,
      }}
      {...props}
    />
  );
}

type SkeletonIconProps = React.HTMLAttributes<HTMLDivElement> & {
  size?: number;
  className?: string;
};

function SkeletonIcon({ size = 16, className, ...props }: SkeletonIconProps) {
  return (
    <div
      data-slot="skeleton-icon"
      className={cn('bg-grey-30 rounded animate-pulse shrink-0', className)}
      style={{
        width: `${size}px`,
        height: `${size}px`,
      }}
      {...props}
    />
  );
}

type SkeletonSpinnerProps = React.HTMLAttributes<HTMLDivElement> & {
  size?: number;
  className?: string;
};

function SkeletonSpinner({ size = 16, className, ...props }: SkeletonSpinnerProps) {
  return (
    <div
      data-slot="skeleton-spinner"
      className={cn('relative shrink-0', className)}
      style={{
        width: `${size}px`,
        height: `${size}px`,
      }}
      {...props}
    >
      <div
        className="absolute inset-0 border-4 border-grey-30 border-t-grey-50 rounded-full animate-spin"
        style={{
          animation: 'spin 1s linear infinite',
        }}
      />
    </div>
  );
}

function SkeletonSpinnerCentered(props: SkeletonSpinnerProps) {
  return (
    <div className="flex items-center justify-center overflow-hidden grow">
      <SkeletonSpinner {...props} />
    </div>
  );
}

export { SKELETON_ROW_HEIGHT, SkeletonLoader, SkeletonIcon, SkeletonSpinner, SkeletonSpinnerCentered };
